export default __webpack_public_path__ + "static/before-1-a6a1e0c3fdcb5d1807a90f986d3edff3.jpg";